export const SALE_TYPE = {
  VARIANT: 'VARIANT',
  PACK: 'PACK',
}

export const PRODUCT_GROUP = {
  TIRES: 'TIRES',
  PARTS: 'PARTS',
  OTHERS: 'OTHERS',
}

export const STOCK_TYPE = {
  STOCK: 'STOCK',
  NONSTOCK: 'NONSTOCK',
  SERVICE: 'SERVICE',
}

export const VAT_TYPE = {
  NO_VAT: 'NO_VAT',
  VAT0: 'VAT0',
  VAT7: 'VAT7',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const BRAND = [
  { value: '', text: 'ทั้งหมด' },
  { value: 'HINO', text: 'HINO' },
  { value: 'SHACMAN', text: 'SHACMAN' },
  { value: 'FUSO (FN527)', text: 'FUSO (FN527)' },
  { value: 'DONGFONG', text: 'DONGFONG' },
  { value: 'bigben', text: 'bigben' },
  { value: 'ISUZU', text: 'ISUZU' },
  { value: 'SUZUKI', text: 'SUZUKI' },
  { value: 'TOYOTA', text: 'TOYOTA' },
  { value: 'VOLVO', text: 'VOLVO' },
  { value: 'TOMI', text: 'TOMI' },
]

export const CATEGORY = [
  { value: '', text: 'ทั้งหมด' },
  { value: 'ระบบ เครื่องยนต์', text: 'ระบบ เครื่องยนต์' },
  { value: 'ระบบ ช่วงล่าง / เกียร์', text: 'ระบบ ช่วงล่าง / เกียร์' },
  { value: 'ระบบ ไฟ', text: 'ระบบ ไฟ' },
  { value: 'ระบบ น้ำมันต่างๆ', text: 'ระบบ น้ำมันต่างๆ' },
  { value: 'ระบบสี', text: 'ระบบสี' },
  { value: 'ระบบแก๊ส', text: 'ระบบแก๊ส' },
  { value: 'หัวเก๋ง', text: 'หัวเก๋ง' },
  { value: 'ระบบลม', text: 'ระบบลม' },
  { value: 'ระบบแอร์', text: 'ระบบแอร์' },
  { value: 'อื่นๆ', text: 'อื่นๆ' },
]

export const TIRETYPE = [
  { value: '', text: 'ทั้งหมด' },
  { value: 'ยางรถเล็ก', text: 'ยางรถเล็ก' },
  { value: 'ยางหล่อดอก', text: 'ยางหล่อดอก' },
  { value: 'ยางตัน', text: 'ยางตัน' },
  { value: 'ยางใช้ยางใน', text: 'ยางใช้ยางใน' },
  { value: 'ยางเรเดียลดอกเล็กใช้ยางใน', text: 'ยางเรเดียลดอกเล็กใช้ยางใน' },
  { value: 'ยางเรเดียลดอกเล็กไม่ใช้ยางใน', text: 'ยางเรเดียลดอกเล็กไม่ใช้ยางใน' },
]

export const STATUS = [
  { value: 'ALL', text: 'ทั้งหมด' },
  { value: 'NEWSTOCK', text: 'สต๊อกใหม่' },
  { value: 'USING', text: 'ใช้อยู่' },
  { value: 'OLDSTOCK', text: 'สต๊อกเก่า' },
  { value: 'WAITFORSALE', text: 'รอจำหน่าย' },
  { value: 'SOLD', text: 'ขายแล้ว' },
  { value: 'LOST', text: 'นำออก' },
]

export const STATUSTEXTSELECTOR = (status) => {
  switch (status) {
    case STATUS[0].value:
      return STATUS[0].text
    case STATUS[1].value:
      return STATUS[1].text
    case STATUS[2].value:
      return STATUS[2].text
    case STATUS[3].value:
      return STATUS[3].text
    case STATUS[4].value:
      return STATUS[4].text
    case STATUS[5].value:
      return STATUS[5].text
    case STATUS[6].value:
      return STATUS[6].text
    default:
      return 'ไม่ระบุ'
  }
}

export const LOSTREASON = [
  'ระเบิด',
  'แตกแก้ม',
  'ยางบวม',
  'หมดดอก',
  'สูญหาย',
]
